import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Header from '../../components/Header/Header';
import styles from './Login.module.css';
import logo from '../../assets/images/wwm-logo-2.png';

function LoginPage() {
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);
  const [hasTriedLogin, setHasTriedLogin] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const checkLogin = async () => {
      try {
        const res = await axios.get('/.auth/me', { withCredentials: true });
        const data = res.data;

        const clientPrincipal = data.clientPrincipal;

        if (!clientPrincipal || !clientPrincipal.userDetails) {
          setIsCheckingAuth(false);
          return;
        }
        setHasTriedLogin(true);
        navigate('/applicationmenu');
      } catch (err) {
        console.error('[Login] Auth Error:', err);
        if (hasTriedLogin) {
          setError('Login failed: ' + err.message);
        }
        setIsCheckingAuth(false);
      }
    };

    checkLogin();
  }, [navigate, hasTriedLogin]);

  const handleLogin = () => {
    window.location.href = '/.auth/login/aad';
  };

  return (
    <div className={styles.pageContainer}>
      <Header />
      <div className={styles.loginBox}>
        <img src={logo} alt="Logo" className={styles.logoImage} />
        {error && hasTriedLogin && <div className={styles.errorMessage}>{error}</div>}
        {!isCheckingAuth ? (
          <button className={styles.loginButton} onClick={handleLogin} aria-label="Login">
            Sign in with Azure AD
          </button>
        ) : (
          <div className={styles.loadingText}>Checking login status...</div>
        )}
      </div>
    </div>
  );
}

export default LoginPage;
